import { Injectable, inject, signal } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, of, tap, throwError } from 'rxjs';
import { environment, endpoints } from '@environment';
import { FiProfile, FiProfileRequest } from '@core/models';

@Injectable({ providedIn: 'root' })
export class FiProfileService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/${endpoints.v1.fiProfile}`;

  private profileCache = signal<FiProfile | null>(null);

  getProfile(): Observable<FiProfile | null> {
    return this.http.get<FiProfile | null>(this.baseUrl).pipe(
      tap((profile) => this.profileCache.set(profile)),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 204 || error.status === 404) {
          this.profileCache.set(null);
          return of(null);
        }
        return throwError(() => error);
      })
    );
  }

  saveProfile(request: FiProfileRequest): Observable<FiProfile> {
    return this.http.post<FiProfile>(this.baseUrl, request).pipe(
      tap((profile) => this.profileCache.set(profile))
    );
  }

  getBaseCurrencyCodeFromCache(): string {
    return this.profileCache()?.baseCurrencyCode ?? 'USD';
  }
}
